import { useContext, useEffect, useState } from "react"
import { CSvgArrowRight, CSvgCalender, CSvgList } from '../../components/CSvg'
import { Link, useNavigate } from "react-router-dom";
import { ContextNav } from "../../context";
import { Pagination, ModalFilterDate, NavBar } from "../../components";
import { handelGetListRollCallMethod } from '../../methods'
import { SkeletonRollCall } from "../../components/Skeleton";
import { ConverDurationToMin, ConvertMiladiDateToJalili, ConvertStringDateToNumberDate, GetToDay, StartCurrentMonth } from "../../utils";


export const Rollcall = () => {
    const navigate = useNavigate();
    const CtxNav = useContext(ContextNav)
    const [displaySkeleton, setDisplaySkeleton] = useState<boolean>(false)
    const [displayBtn, setDisplayBtn] = useState<boolean>(false)
    const [rollCall, setRollCall] = useState<any>(null)
    const [visibleDate, setVisibleDate] = useState<boolean>(false)
    const [dateFilter, setDateFilter] = useState<any>(null)
    const [pagination, setPagination] = useState({
        'current': 1,
        'total': 1,
    })

    const handelFilterDate = () => {
        handelGetListRollCallMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setRollCall, setDisplaySkeleton, pagination, setPagination)
    }

    useEffect(() => {
        document.title = "گزارش تردد | دایان"
        if (pagination.current) {
            handelGetListRollCallMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setRollCall, setDisplaySkeleton, pagination, setPagination)
        }
    }, [pagination?.current])

    return (
        <>
            <div className='w-full min-h-screen flex flex-col'>
                <NavBar title='گزارش تردد' isCalender={true} onClickCalender={() => { setVisibleDate(true) }} />
                <div className='w-full flex flex-col p-[20px]'>
                    <div className='w-full flex flex-col overflow-hidden '>
                        <div className='w-full h-[45px] py-[5px] rounded-md border border-dayan-orange-50 flex items-center text-sm'>
                            <div className='w-full h-full border-l border-dayan-orange-50 flex items-center justify-center text-dayan-orange-50'>روز</div>
                            <div className='w-full h-full border-l border-dayan-orange-50 flex items-center justify-center text-dayan-orange-50'>ورود</div>
                            <div className='w-full h-full border-l border-dayan-orange-50 flex items-center justify-center text-dayan-orange-50'>خروج</div>
                            <div className='w-full h-full  flex items-center justify-center text-dayan-orange-50'>کارکرد</div>
                        </div>
                        {displaySkeleton == false && rollCall?.logs?.data?.map((item: any, index: number) =>
                            <div key={index} className='w-full min-h-[55px] py-[5px] flex items-center bg-[#f9f9f9] shadow rounded-md mt-3 sm:text-sm text-xs'>
                                <div className='w-full  flex flex-col items-center justify-center text-center border-l border-gray-400 px-1'>
                                    {/* <span>سه شنبه</span> */}
                                    <span>{ConvertMiladiDateToJalili(item?.date.slice(0, 10))}</span>
                                </div>
                                <div className='w-full  flex flex-col items-center justify-center text-center border-l border-gray-400 px-1'>{item?.entrance.slice(10, 16)}</div>
                                <div className='w-full  flex flex-col items-center justify-center text-center border-l border-gray-400 px-1'>{item?.date.slice(10, 16)}</div>
                                <div className='w-full flex flex-col items-center justify-center text-center px-1'>{item?.duration && item?.duration > 0 && ConverDurationToMin(item?.duration)}</div>
                            </div>
                        )}
                        {displaySkeleton == false && rollCall?.logs?.data?.length == 0 &&
                            <div className="w-full h-[200px] flex justify-center items-center text-gray-400">
                                <span>موردی یافت نشد !</span>
                            </div>
                        }
                        {displaySkeleton && <SkeletonRollCall />}
                        <Pagination pagination={pagination} setPagination={setPagination} loading={displaySkeleton} />
                        {rollCall?.logs?.data?.length != 0 &&
                            <div className='w-full h-[45px] bg-dayan-orange-50 flex items-center justify-between rounded-md my-[30px] px-[20px] text-white text-sm'>
                                <span>مجموع کارکرد</span>
                                <span>{rollCall?.total_duration > 0 && ConverDurationToMin(rollCall?.total_duration)}</span>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <ModalFilterDate
                visible={visibleDate}
                setVisible={setVisibleDate}
                dateKeeper={dateFilter}
                setDateKeeper={setDateFilter}
                btnLoader={displayBtn}
                onFinish={handelFilterDate}
            />

        </>
    );
}